module.exports = __webpack_public_path__ + "img/google_url.acfb87a1.svg";